/**
 * Relevés de coût, pour les mesures de performance.
 *
 * Un seul chiffre compte vraiment ici : le temps de calcul d'un jet. Il est payé sur
 * le fil principal, au moment où le joueur appuie, et le plan pose la question
 * explicitement (§ 7.1) — s'il se voit sur téléphone, il faudra passer par un Web
 * Worker. On ne peut y répondre qu'en le mesurant là où il se produit.
 *
 * Volontairement minimal et sans dépendance : ce module ne doit rien coûter quand
 * personne ne regarde.
 */

interface Releve {
  readonly ms: number;
  readonly des: number;
  readonly simulations: number;
}

let dernier: Releve | null = null;
const historique: Releve[] = [];
/** Assez pour une session de jeu, assez peu pour ne pas fuir. */
const MAX_HISTORIQUE = 200;

export function noterCalculDeJet(releve: Releve): void {
  dernier = releve;
  historique.push(releve);
  if (historique.length > MAX_HISTORIQUE) historique.shift();
}

export function dernierCalculDeJet(): Releve | null {
  return dernier;
}

/** Statistiques du coût de calcul, ou `null` si aucun jet n'a été calculé. */
export function coutDesJets(): {
  n: number; min: number; median: number; max: number; simulations: number;
} | null {
  if (historique.length === 0) return null;
  const durees = historique.map((r) => r.ms).sort((a, b) => a - b);
  return {
    n: durees.length,
    min: durees[0]!,
    median: durees[Math.floor(durees.length / 2)]!,
    max: durees[durees.length - 1]!,
    simulations: historique.reduce((t, r) => t + r.simulations, 0) / historique.length,
  };
}
